/* eslint-disable max-lines-per-function */
/* eslint-disable camelcase */
import {ALL_PRODUCTS_GROUP_ID, DEFAULT_PAGE_SIZE, DEFAULT_SECTION} from './constants';

/**
 * @param {import('custom-extensions/search/lib/api/types').SearchRequestFilter[]} filters
 * @returns {Pick<import('@constructor-io/constructorio-client-javascript').SearchParameters, 'filters' | 'preFilterExpression'>}
 */
export const transformFilters = filters => {
	if (!filters || !filters.length) {
		return {};
	}

	const userFilters = {};
	const backgroundExpressions = [];

	for (const filter of filters) {
		const isRange = Array.isArray(filter.value);

		if (filter.background) {
			backgroundExpressions.push(isRange
				? {
					name: filter.field,
					range: [
						filter.value[0] ?? '-inf',
						filter.value[1] ?? 'inf'
					]
				}
				: {
					name: filter.field,
					value: filter.value
				});
			continue;
		}

		if (isRange) {

			/*
			 * Constructor's REST-level `filters` param encodes a range as a
			 * single "min-max" string (e.g. `filters[price]=100-200`).
			 */
			userFilters[filter.field] = `${filter.value[0] ?? ''}-${filter.value[1] ?? ''}`;

			continue;
		}

		userFilters[filter.field] = userFilters[filter.field] || [];
		userFilters[filter.field].push(filter.value);
	}

	const groupedByField = backgroundExpressions.reduce((groups, expression) => {
		groups[expression.name] = groups[expression.name] || [];
		groups[expression.name].push(expression);

		return groups;
	}, {});

	const preFilterClauses = Object.values(groupedByField).map(expressions => {
		return expressions.length > 1
			? {or: expressions}
			: expressions[0];
	});

	return {
		...Object.keys(userFilters).length
			? {filters: userFilters}
			: {},
		...preFilterClauses.length
			? {
				preFilterExpression: preFilterClauses.length > 1
					? {and: preFilterClauses}
					: preFilterClauses[0]
			}
			: {}
	};
};

/**
 *
 * @typedef {object} TransformedSearchRequest
 * @property {string} filterName Browse filter field name (e.g. `group_id`) -- only meaningful when `isBrowse` is true
 * @property {string} [filterValue] Browse filter value (the category id) -- only meaningful when `isBrowse` is true
 * @property {boolean} isBrowse `true` when this should call `browse.getBrowseResults()` instead of `search.getSearchResults()`
 * @property {import('@constructor-io/constructorio-client-javascript').SearchParameters} parameters
 * @property {string} term The raw search query term (empty string on a browse request)
 *
 * @param {import('custom-extensions/search/lib/api/types').SearchRequest} request
 * @returns {TransformedSearchRequest}
 */
export const transformSearchRequest = request => {
	const term = request.search || request.q || '';

	return {
		filterName: 'group_id',
		filterValue: ALL_PRODUCTS_GROUP_ID,
		isBrowse: !term,
		parameters: {
			...transformFilters(request.filters),
			page: parseInt(request.page, 10) || 1,
			resultsPerPage: parseInt(request.resultsPerPage || DEFAULT_PAGE_SIZE, 10),
			section: DEFAULT_SECTION,
			...request?.sorting?.field
				? {
					sortBy: request.sorting.field,
					sortOrder: request.sorting.direction === 'asc' ? 'ascending' : 'descending'
				}
				: {}
		},
		term
	};
};
